import React, { useMemo } from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import {
  Breadcrumb,
  MODEL_JSON_STORE_NAME,
  selectBreadcrumbs,
  selectSeoProperties,
  selectCurrentUrl,
} from 'modules/model-json';
import { COOKIES_STORE_NAME, selectPageViewData } from 'modules/cookies';
import { State } from 'store/types';
import { usePageViewEvent } from '../../hooks';
import { Breadcrumbs } from '../breadcrumbs';
import { SeoText } from '../seo-text';

type RootLayoutProps = {
  children: React.ReactNode;
  currentPage: string;
  customBreadcrumbs?: Breadcrumb[];
  showCurrentPage?: boolean;
};

/**
 * Вью лендинга
 */
export const RootLayout: React.FC<RootLayoutProps> = ({
  children,
  currentPage,
  customBreadcrumbs,
  showCurrentPage = false,
}) => {
  const { modelJson, cookies } = useStoreon<State>(MODEL_JSON_STORE_NAME, COOKIES_STORE_NAME);
  const seoProperties = useMemo(() => selectSeoProperties(modelJson), [modelJson]);
  const breadcrumbs = useMemo(() => customBreadcrumbs || selectBreadcrumbs(modelJson), [
    customBreadcrumbs,
    modelJson,
  ]);
  const currentUrl = useMemo(() => selectCurrentUrl(modelJson), [modelJson]);
  const pageViewData = useMemo(() => selectPageViewData(cookies), [cookies]);

  usePageViewEvent(currentUrl, 'Landing', pageViewData);

  return (
    <>
      <Layout>
        <Breadcrumbs breadcrumbs={breadcrumbs} currentPage={currentPage} showCurrentPage={showCurrentPage} />
      </Layout>
      {children}
      <Layout>
        <SeoText seoProperties={seoProperties} />
      </Layout>
    </>
  );
};
